import React, { Fragment, useEffect, useMemo, useState } from 'react'

import './search.css'
import SearchedProduct from './SearchedProduct'

function PagenationForProduct({ product, itemsPerPage, loading }) {
    const products = useMemo(() => Array.isArray(product) ? product : [], [product]);
    const [currentPage, setCurrentPage] = useState(0);

    const pageCount = Math.max(1, Math.ceil(products.length / itemsPerPage));

    const currentItems = useMemo(() => {
        const startOffset = currentPage * itemsPerPage;
        return products.slice(startOffset, startOffset + itemsPerPage);
    }, [currentPage, itemsPerPage, products]);

    useEffect(() => {
        setCurrentPage(0);
    }, [products.length, itemsPerPage]);

    const goToPage = (page) => {
        setCurrentPage(Math.max(0, Math.min(page, pageCount - 1)));
    };

    return (
        <Fragment>
            <div className="search-data-container-and-data-filters">
                <SearchedProduct currentItems={currentItems} loading={loading} />
            </div>

            {pageCount > 1 && (
                <nav className="react-pagenation-container" aria-label="Search results pages">
                    <button
                        type="button"
                        className="react-pagenation-prev-a"
                        disabled={currentPage === 0}
                        onClick={() => goToPage(currentPage - 1)}
                    >
                        Prev
                    </button>

                    {Array.from({ length: pageCount }, (_, index) => (
                        <button
                            type="button"
                            key={index}
                            className={
                                index === currentPage
                                    ? 'react-pagenation-page-div-a react-pagenation-active-class-a'
                                    : 'react-pagenation-page-div-a'
                            }
                            onClick={() => goToPage(index)}
                        >
                            {index + 1}
                        </button>
                    ))}

                    <button
                        type="button"
                        className="react-pagenation-prev-a"
                        disabled={currentPage >= pageCount - 1}
                        onClick={() => goToPage(currentPage + 1)}
                    >
                        Next
                    </button>
                </nav>
            )}
        </Fragment>
    )
}

export default PagenationForProduct
